exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-dfdd1996] .el-input__inner {\n  padding-right: 50px !important;\n}\n[data-v-dfdd1996] .el-textarea__inner {\n  padding-right: 55px !important;\n  max-height: 100px !important;\n}\n", ""]);

// exports
